import DOMPurify from 'dompurify';

export interface SanitizationConfig {
  allowedTags?: string[];
  allowedAttributes?: string[];
}

const DEFAULT_CONFIG: SanitizationConfig = {
  allowedTags: ['b', 'strong', 'i', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'li'],
  allowedAttributes: []
};

export function sanitizeHtml(html: string, config: SanitizationConfig = DEFAULT_CONFIG): string {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const cleanConfig = {
    ALLOWED_TAGS: config.allowedTags || DEFAULT_CONFIG.allowedTags,
    ALLOWED_ATTR: config.allowedAttributes || DEFAULT_CONFIG.allowedAttributes,
    KEEP_CONTENT: true,
    REMOVE_TAGS: [],
    FORBID_TAGS: [],
    FORBID_ATTR: ['style', 'class', 'id', 'onclick', 'onload', 'onerror'],
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false,
    WHOLE_DOCUMENT: false,
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
    RETURN_TRUSTED_TYPE: false
  };

  return DOMPurify.sanitize(html, cleanConfig);
}

export function sanitizeProductField(value: string): string {
  if (!value) return '';
  
  // Only sanitize if the value contains HTML tags
  if (/<[^>]*>/.test(value)) {
    // Use expanded config for product descriptions that support WYSIWYG editing
    const productConfig: SanitizationConfig = {
      allowedTags: ['b', 'strong', 'i', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'li'],
      allowedAttributes: []
    };
    return sanitizeHtml(value, productConfig);
  }
  
  // Return plain text as-is (preserving spaces)
  return value;
}